// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store/main'
import EventBus from './event-bus'
import 'vue-material-design-icons/styles.css'
import Icon from '@/components/generics/Icon'
import VueCookies from 'vue-cookies'
import { abilitiesPlugin, Can } from '@casl/vue'
import User from '@/lib/transfer-objects/User'
import { USER_REQUEST } from 'actions/user'
import { REFRESH_ABILITIES } from '@/lib/enums/events/app'
import axios from 'axios'
import _ from 'lodash'
import pluralize from '@/modules/Pluralize'
import dateFormat from 'dateformat'
import 'vue-search-select/dist/VueSearchSelect.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { OktaAuth } from '@okta/okta-auth-js'
import 'vue-loading-overlay/dist/vue-loading.css'
import OktaVue from '@okta/okta-vue'
Vue.component('v-select', vSelect)
Vue.prototype.$isDev = process.env.NODE_ENV === 'development'
Vue.prototype.$dateFormat = dateFormat
Vue.prototype.$_ = _
Vue.prototype.$axios = axios
Vue.prototype.$pluralize = pluralize
Vue.prototype.$bus = EventBus

const oktaAuth = new OktaAuth({
  issuer: process.env.OKTA_AUTH.BASE_URL,
  clientId: process.env.OKTA_AUTH.CLIENT_ID,
  redirectUri: window.location.origin + '/callback',
  scopes: ['openid', 'profile', 'email']
})

Vue.use(OktaVue, { oktaAuth })

Vue.use({
  install (vue, opts = {}) {
    const axiosAdminConfig = {
      baseURL: process.env.API.ADMINISTRATION.BASE_URL,
      timeout: 300000
    }
    vue.prototype.$administrationApi = axios.create(axiosAdminConfig)
    vue.prototype.$auth.isAuthenticated().then(response => {
      if (response === true) {
        vue.prototype.$administrationApi.interceptors.request.use(
          async config => {
            await vue.prototype.$auth.getUser().then(response => {
              config.headers = {
                'Authorization': `Bearer ${vue.prototype.$auth.getAccessToken()}`,
                'username': response.preferred_username
              }
            })
            return config
          },
          error => {
            Promise.reject(error)
          })
        vue.prototype.$administrationApi.get('users/me')
          .then((response) => {
            try {
              var userData = response.data
              var user = new User(userData)
              if (!user.isBackOfficeAllowed) {
                if (router.history.current.name !== 'MonitoringIndex') {
                  router.push({name: 'NotAllowed'})
                }
              }
              store.dispatch(USER_REQUEST, user)
              EventBus.$emit(REFRESH_ABILITIES, user)
            } catch (error) {
              if (router.history.current.name !== 'MonitoringIndex') {
                console.error('unable to retrieve current user', error)
                router.push({name: 'NotAllowed'})
              }
            }
          }).catch((error) => {
            if (router.history.current.name !== 'MonitoringIndex') {
              console.error('unable to retrieve current user', error)
              router.push({name: 'NotAllowed'})
            }
          })
      }
    })
  }
})

Vue.use(abilitiesPlugin)
Vue.use(BootstrapVue)
Vue.use(VueCookies)
// Load global components
Vue.component('Icon', Icon)
Vue.component('Can', Can)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#main-app',
  router,
  store,
  template: '<App/>',
  components: { App }
})




// WEBPACK FOOTER //
// ./src/main.js